import { EntityReference } from '../../core/entities/shared/entity-reference.entity';
import { FormOptions } from './base.form-options';

export class QuickActionFormOptions extends FormOptions {
  locations: EntityReference[] = [];
}
